import toast from "react-hot-toast";

export const Notification = (msg, type, duration) => {
  const options = {
    duration: 1500,
    type: type,
    position: "top-center",
    zIndex: 999999999,
  };
  return toast(msg, options);
};
